/**
 * Get emoji for speaker title/role
 * @param {string} title - Speaker's job title
 * @returns {string} - Relevant emoji for the role
 */
export function getSpeakerEmoji(title) {
  if (!title) return '👤'
  
  const titleLower = title.toLowerCase()
  
  // Executive roles
  if (titleLower.includes('ceo') || titleLower.includes('co-founder') || titleLower.includes('founder')) {
    return '👑'
  }
  
  // VP and C-level
  if (titleLower.includes('vp') || titleLower.includes('vice president') || titleLower.includes('chief')) {
    return '🎯'
  }
  
  // Directors
  if (titleLower.includes('director')) {
    return '🎪'
  }
  
  // Product roles
  if (titleLower.includes('product')) {
    return '📦'
  }
  
  // Engineering roles
  if (titleLower.includes('engineer') || titleLower.includes('engineering')) {
    return '⚙️'
  }
  
  // UX/Design roles
  if (titleLower.includes('ux') || titleLower.includes('design')) {
    return '🎨'
  }
  
  // Sales roles
  if (titleLower.includes('sales') || titleLower.includes('revenue')) {
    return '💼'
  }
  
  // Partnership roles
  if (titleLower.includes('partner') || titleLower.includes('partnership')) {
    return '🤝'
  }
  
  // Marketing roles
  if (titleLower.includes('marketing')) {
    return '📢'
  }
  
  // Manager roles
  if (titleLower.includes('manager') || titleLower.includes('lead')) {
    return '👥'
  }
  
  // Enterprise roles
  if (titleLower.includes('enterprise')) {
    return '🏢'
  }
  
  // Technical/Architect roles
  if (titleLower.includes('architect') || titleLower.includes('cto')) {
    return '🏗️'
  }
  
  // Default
  return '👤'
} 